// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://iesnxcfhhtlsfqnfpwkt.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imllc254Y2ZoaHRsc2ZxbmZwd2t0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE5NTQ3NjAsImV4cCI6MjA2NzUzMDc2MH0.irsU2aFA29w6jHrGL4d4HFacBg5oCH4LocT2sERXy64';

export const supabase = createClient(supabaseUrl, supabaseKey);
